export const ALL_OPTION_ID = 'all'

export const ALL_OPTION = Object.freeze({
    id: ALL_OPTION_ID,
    name: 'All',
})

export const NO_RESULTS_MENU_ITEM_PROPS = Object.freeze({
    disabled: true,
    text: 'No results',
})

export const TEMPLATE_TYPE_OPTIONS = Object.freeze([
    {
        id: 'runbook_framework',
        name: 'Runbook framework',
    },
    {
        id: 'action_group',
        name: 'Action group',
    },
])

export const RUNBOOK_CATEGORY_OPTIONS = Object.freeze([
    ALL_OPTION,
    {
        id: 'cybersecurity',
        name: 'Cybersecurity',
    },
    {
        id: 'failover',
        name: 'Failover',
    },
    {
        id: 'restart',
        name: 'Restart',
    },
])

export const DEVICE_TYPE_OPTIONS = Object.freeze([
    ALL_OPTION,
    {
        id: 'server',
        name: 'Server',
    },
    {
        id: 'network',
        name: 'Network',
    },
    {
        id: 'storage',
        name: 'Storage',
    },
    {
        id: 'wp',
        name: 'WP',
    },
])
